module.exports = __webpack_public_path__ + "img/new_account.3f9ffa6d.svg";